export function routes($stateProvider) {
    $stateProvider
        .state('app.lab.clients', {
        url: '/clientes',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.lab.clients.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        controller: 'LmeListClientsController',
        controllerAs: 'vm',
        template: require('./directory/directory.view.html'),
        role: 'clientesLMEList',
        title: 'Clientes',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.lab.clients.details', {
        url: '/{id}',
        controller: 'LmeDetailsClientsController',
        controllerAs: 'vm',
        template: require('./details/details.view.html'),
        role: 'clientesLMEList',
        title: 'Detalhes de Cliente'
    });
}
routes.$inject = ['$stateProvider'];
